import Types from "./Types";
/* eslint-disable camelcase */

/************************************************
Get inventoryStock details
*************************************************/

const getInventoryStock = query => {
  return { type: Types.GET_INVENTORY_STOCK, query };
};

const getInventoryStockSuccess = inventoryStock => ({
  type: Types.GET_INVENTORY_STOCK_SUCCESS,
  inventoryStock
});

const getInventoryStockFailure = error => ({
  type: Types.GET_INVENTORY_STOCK_FAILURE,
  error
});

/************************************************
getInventoryWarehouse
*************************************************/

const getInventoryWarehouse = query => {
  return { type: Types.GET_INVENTORY_WAREHOUSE, query };
};

const getInventoryWarehouseSuccess = warehouses => ({
  type: Types.GET_INVENTORY_WAREHOUSE_SUCCESS,
  warehouses
});

const getInventoryWarehouseFailure = error => ({
  type: Types.GET_INVENTORY_WAREHOUSE_FAILURE,
  error
});

export {
  getInventoryStock,
  getInventoryStockSuccess,
  getInventoryStockFailure,
  getInventoryWarehouse,
  getInventoryWarehouseSuccess,
  getInventoryWarehouseFailure
};



// WEBPACK FOOTER //
// ./src/actions/InventoryActions.js